// Dados no formato do front

export interface ISecao {
  id: string;
  // pagina_id: string;
  qtdeDados?: number;
  objetos: IObjeto[];
}

export interface IObjeto {
  id: string;
  nome: string;
  tipo: string;
  percentual_tela: number;
  series?: IDadosGraficoSerieUnica[] | null;
  multiplas_series?: IDadosGraficoSeriesMultiplas[] | null;
  graficoRadar?: IDadosGraficoRadar[] | null;
  cartao?: IDadoCard;

  [key: string]: any; // Adiciona suporte para chaves dinâmicas
}

export interface IDadoCard {
  valor: string;
  percentual?: number;
  descricao?: string;
}

export interface IDadosGraficoSerieUnica {
  name: string;
  value: number;
  date: Date;
}

export class IDadosGraficoSeriesMultiplas {
  name: string; // Propriedade fixa
  [key: string]: any; // Permite propriedades dinâmicas

  constructor(name: string, data: { [key: string]: number }) {
    this.name = name;
    Object.assign(this, data); // Atribui dinamicamente as propriedades
  }
}

export class IDadosGraficoRadar {
  subject: string; // Propriedade fixa
  [key: string]: string | number; // Propriedades dinâmicas (ex.: A, B, etc.)

  constructor(subject: string, series: { [key: string]: number }) {
    this.subject = subject;
    Object.assign(this, series); // Atribui dinamicamente as séries
  }
}
